import DeputyEdit from './DeputyEdit.container';

export default DeputyEdit;
